(function ($, w, d) {
    w.Application = function () {
        this.$modal = null

        $(d).ready($.proxy(this.init, this))
    };

    w.Application.prototype = {
        init: function () {

        },
        showModal: function (url, params) {
            let width = !1

            // закроем предыдущие окна
            this.closeModal()
            this.$modal = $.fancybox.open({
                src: url,
                type: "ajax",
                opts: {
                    hideScrollbar: false,
                    touch: false,
                    autoFocus: false,
                    ajax: {
                        settings: {
                            method: 'POST',
                            data: params
                        }
                    },
                    buttons: [
                        "close"
                    ],
                    mobile: {
                        preventCaptionOverlap: true
                    },
                    baseTpl:
                        '<div class="fancybox-container" role="dialog" tabindex="-1">' +
                        '<div class="fancybox-bg"></div>' +
                        '<div class="fancybox-inner">' +
                        '<div class="fancybox-stage"></div>' +
                        "</div>" +
                        "</div>",
                    btnTpl: {
                        smallBtn: '<span data-fancybox-close class="close-button" title="{{CLOSE}}"><svg class="svg-icon"><use xlink:href="#svg_close"></use></svg></span>'
                    }
                }
            })
        },
        closeModal: function () {
            if (!!this.$modal) {
                this.$modal.close()
                this.$modal = null
            }
        },
        closeProject: function (projectID) {
            $.ajax({
                type: 'POST',
                url: '/ajax/project.php',
                data: {'action': 'close', 'id': projectID},
                dataType: 'json',
                success: result => {
                    if (typeof result === 'object') {
                        if (result.success === true)
                            window.location.href = '/projects/completed/' + projectID + '/'

                    }
                }
            })
        }
    }
})(jQuery, window, document)

let app = new Application()